import * as yup from 'yup';

export const RiskAssessmentSchema = yup.object({
  risk: yup.boolean().notRequired().nullable(),
  note: yup.string().required('description.required'),
});

export type IRiskAssessment = { risk: boolean; note: string };
